const LandingPageSectionTitle = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-section-title" */ '@/app/views/client-view/landing-page/components/_shared/landing-page-section-title/landing-page-section-title.vue');
const LandingPageMobileDisplay = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-mobile-display" */ '@/app/views/client-view/landing-page/components/_shared/landing-page-mobile-display/landing-page-mobile-display.vue');

export default {
    name: 'LandingPageTreatment',
    components: {
        LandingPageSectionTitle,
        LandingPageMobileDisplay
    },
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() {},
    methods: {},
    // third party libraries
}